module.exports = __webpack_public_path__ + "img/tk.e5fa89e.svg";